import { createSlice } from "@reduxjs/toolkit";

export const navSlice = createSlice({
  name: "toggle",
  initialState: { toggle: false },
  reducers: {
    toggleSwitch: (state) => {
      state.toggle = !state.toggle;
    },
  },
});

export const { toggleSwitch } = navSlice.actions;

export default navSlice.reducer;
